<template>
    <div
        @click="handleButtonClick"
        class="af-google-drive-picker"
    >
        {{ $t('resume.googledrive_title') }}
    </div>
</template>

<script>
    import isEmpty from 'lodash/isEmpty';

    export default {
        name: 'GoogleDrivePicker',

        data() {
            return {
                clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
                scope: 'https://www.googleapis.com/auth/drive',
                oauthToken: null,
                pickerApiLoaded: false,
            };
        },

        mounted() {
            if(!window.gapi){
                const gDrive = document.createElement('script');
                gDrive.setAttribute('src', 'https://apis.google.com/js/api.js');
                document.head.appendChild(gDrive);
            }
        },

        methods: {

            onAuthApiLoad() {
                window.gapi.auth.authorize(
                    {
                        'client_id': this.clientId,
                        'scope': this.scope,
                        'immediate': false,
                    },
                    this.handleAuthResult);
            },
            
            onPickerApiLoad() {
                this.pickerApiLoaded = true;
                this.createPicker();
            },

            handleAuthResult(authResult) {
                if (authResult && !authResult.error) {
                    this.oauthToken = authResult.access_token;
                    this.createPicker();
                } else {
                    return console.warn(authResult.details);
                }
            },

            // function called on click of drive icon
            async handleButtonClick() {
                if(window.gapi){
                    await window.gapi.load('auth', {'callback': this.onAuthApiLoad});
                    await window.gapi.load('picker', {'callback': this.onPickerApiLoad});
                }
            },

            // Create and render a Picker object for picking user Photos.
            createPicker() {
                if (this.pickerApiLoaded && this.oauthToken) {
                    var picker = new window.google.picker.PickerBuilder()
                        .addViewGroup(
                            new window.google.picker.ViewGroup(window.google.picker.ViewId.DOCS).
                                addView(window.google.picker.ViewId.DOCUMENTS).
                                addView(window.google.picker.ViewId.PDFS))
                        .setMaxItems(1)
                        .setOAuthToken(this.oauthToken)
                        .setCallback(this.pickerCallback)
                        .build();
                    picker.setVisible(true);
                }
            },
            
            pickerCallback(data) {
                let file = {};
                if (data[window.google.picker.Response.ACTION] == window.google.picker.Action.PICKED) {
                    const doc = data[window.google.picker.Response.DOCUMENTS][0];
                    const file_mime_type = doc.mimeType;
                    let file_extension = '';

                    if(file_mime_type == 'application/msword') {
                        file_extension = 'doc';
                    }
                    else if(file_mime_type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
                        file_extension = 'docx';
                    }
                    else if(file_mime_type == 'application/pdf') {
                        file_extension = 'pdf';
                    }
                   
                    file = {
                        url: doc[window.google.picker.Document.URL],
                        link: `https://www.googleapis.com/drive/v3/files/${doc.id}?alt=media`,
                        name: doc[window.google.picker.Document.NAME],
                        access_token: this.oauthToken,
                        sizeBytes: doc['sizeBytes'],
                        extension: file_extension,
                    };
                }

                if(!isEmpty(file)){
                    this.$emit('gdPicked', file);
                }
            },
        },
    };
</script>